import AlertModal from "@/components/modals/AlertModal";
import ConfirmModal from "@/components/modals/ConfirmModal";
import LoadingModal from "@/components/modals/LoadingModal";
import { createRoot } from "react-dom/client";

export function showConfirmModal({
    title,
    message,
    type = "normal",
}: {
    title: string;
    message: string;
    type?: "normal" | "delete";
}): Promise<boolean> {
    return new Promise((resolve) => {
        const div = document.createElement("div");
        div.classList.add(
            "absolute",
            "inset-0",
            "opacity-0",
            "overflow-hidden",
            "pointer-events-none",
        );
        document.body.appendChild(div);
        const root = createRoot(div);

        const onClose = () => {
            cleanup();
            resolve(false);
        };

        const onConfirm = async () => {
            cleanup();
            resolve(true);
        };

        const cleanup = () => {
            root.unmount();
            div.remove();
        };

        root.render(
            <ConfirmModal
                title={title}
                message={message}
                onClose={onClose}
                onConfirm={onConfirm}
                type={type}
            />,
        );
    });
}

export function showAlertModal({
    message,
    type = "success",
}: {
    message: string;
    type: "success" | "error" | "warning";
}): Promise<void> {
    return new Promise((resolve) => {
        const div = document.createElement("div");
        div.classList.add(
            "absolute",
            "inset-0",
            "opacity-0",
            "overflow-hidden",
            "pointer-events-none",
        );
        document.body.appendChild(div);
        const root = createRoot(div);

        const handleClose = () => {
            root.unmount();
            div.remove();
            resolve();
        };

        root.render(
            <AlertModal message={message} type={type} onClose={handleClose} />,
        );
    });
}

export function showLoadingModal({ message }: { message: string }): () => void {
    const div = document.createElement("div");
    div.classList.add(
        "absolute",
        "inset-0",
        "opacity-0",
        "overflow-hidden",
        "pointer-events-none",
    );
    document.body.appendChild(div);
    const root = createRoot(div);

    root.render(<LoadingModal message={message} />);

    // Close function to unmount the modal
    const closeLoadingModal = () => {
        root.unmount();
        div.remove();
    };

    return closeLoadingModal;
}
